import "core-js/modules/es.array.concat";
import { getUrlParam } from '@tencent/vft-common/util';
import { getVuid } from '@tencent/vft-common/login';
var _window$location = window.location,
    host = _window$location.host,
    pathname = _window$location.pathname;
export default {
  token: getUrlParam('token'),
  vuid: +getVuid(),
  ptag: getUrlParam('ptag'),
  starid: getUrlParam('starid'),
  shareLink: "https://".concat(host).concat(pathname)
};